<template>
	<div id="fundsTransfer" class="input-heading">
		<div v-if="availableOffers.length > 0">
			<div v-if="!restrictedNeedsMoreInfo">
				<h2>{{ languageStrings.buyInOffers }}</h2>
			</div>
			<div v-else class="text-center">
				<!-- <h2>{{ languageStrings.needsMoreInfo }}</h2> -->
				<p v-if="restrictedNeedsMoreInfo">
					<span>{{ languageStrings.currentlyLimited }}</span>
						<span class="encore-color bold-text">{{
							buyInMaxThresholdCOC
						}}</span>
						<span> {{ languageStrings.cashinAmountAnd }}</span>
						<span class="encore-color bold-text">{{
							cashOutThresholdCOC
						}}</span>
				</p>
				<p v-if="restrictedNeedsMoreInfo">{{ languageStrings.ifYouWishToRemoveRestrictions }}</p>
				<!-- <div v-if="!hideProgressBar">
					<div class="encore-color bold-text">{{ getPercentage() }}%</div>
						<div style="margin-bottom: 5%;" class="encore-color bold-text progress-bar-section center-content">
							{{ playthroughProgress }}
							<div class="meter space-between-bar-and-number">
    							<span :id="createId(0)"></span>
  							</div>
							{{ playthroughThreshold }}
						</div>
				</div> -->
			</div>
			<div v-if="availableOffers.length > 0" :class="isMobile ? 'mobile-grid' : ''">
				<p v-if="!webPayOptions.isEmailVerified" class="encore-color bold-text center-text">{{ languageStrings.readyToPlay }}<br>
					<button  class="btn buy-in-btn curved-border"  style="border-color: black !important;"  @click="takeToEditUser()">
						{{languageStrings.verifyEmail }}
					</button>
				</p>
				<div class="buy-in-offer card-container" :class="isMobile ? 'is-mobile' : ''">
					<BuyInOffer
						class="card"
						v-for="(buyInOffer, index) in availableOffersForPlayer"
						:id="`offer-${buyInOffer.id}`"
						:key="index"
						:buyInOffer="buyInOffer"
						:playerState="playerState"
						:inGameCurrencyTool="inGameCurrencyTool"
						:systemCurrencyTool="systemCurrencyTool"
						:languageStrings="languageStrings"
						:languageErrorStrings="languageErrorStrings"
						:systemSettings="systemSettings"
						:webPayOptions="webPayOptions"
						:inGameCurrencyInfo="inGameCurrencyInfo"
						:isMobile="isMobile"
						:restrictedNeedsMoreInfo="restrictedNeedsMoreInfo"
						:hasBeenBlockedForBuyInAndCashOut="hasBeenBlockedForBuyInAndCashOut"
					/>
				</div>
			</div>
		</div>
		<div v-else>
			<h2>{{ languageStrings.noBuyInOffersAvailable }}</h2>
		</div>
	</div>
</template>

<script>
import BuyInOffer from "@/components/BuyInOffer.vue";
import { onBeforeUnmount } from "vue";
import router from "@/router";

export default {
	name: "BuyIns",
	inheritAttrs: false,
	props: {
		playerState: {
			type: Object,
		},
		appDataBus: {
			type: Object,
		},
		isMobile: Boolean,
		inGameCurrencyTool: Object,
		systemCurrencyTool: Object,
		languageStrings: Object,
		languageErrorStrings: Object,
		availableOffers: Array,
		systemSettings: Object,
		webPayOptions: Object,
		inGameCurrencyInfo: Object,
		casinoList: Array,
		hasBeenBlockedForBuyInAndCashOut: Boolean
	},
	components: {
		BuyInOffer,
	},
	data() {
		return {
			status: Object.assign({}, this.globalStatus),
			buyInOffers: this.availableOffers.sort((a, b) => b.priority - a.priority),
			currencyInfo: this.playerState.currencyInfo,
			idCheckNeeded: this.webPayOptions?.taxAmlRestrictions?.idCheckNeeded,
			morePersonalInfoNeeded: this.webPayOptions?.taxAmlRestrictions?.morePersonalInfoNeeded,
			restrictedNeedsMoreInfo:
				this.webPayOptions?.taxAmlRestrictions?.idCheckNeeded ||
				this.webPayOptions?.taxAmlRestrictions?.morePersonalInfoNeeded,
			buyInMaxThresholdCOC:  this.systemCurrencyTool.formatCurrency(
								this.webPayOptions?.taxAmlRestrictions?.buyInThresholdCOC,
								this.systemCurrencyTool.displayType.minorWholeOrFull),

			cashOutThresholdCOC: this.systemCurrencyTool.formatCurrency(
								this.webPayOptions?.taxAmlRestrictions?.cashOutThresholdCOC,
								this.systemCurrencyTool.displayType.minorWholeOrFull),
			availableOffersForPlayer: [],
			welcomeBackBonusAvailable: false,
			firstTimeBuyIn: false,
			playthroughProgress: this.systemCurrencyTool.formatFromAU(this.playerState?.casinoBalances[0]?.playthroughProgressAU,this.systemCurrencyTool.displayType.full),
			playthroughThreshold: this.systemCurrencyTool.formatFromAU(this.playerState?.casinoBalances[0]?.playthroughThresholdAU,this.systemCurrencyTool.displayType.full),
			percentage: null,
			hideProgressBar: false,
		};
	},
	watch:{
		hasBeenBlockedForBuyInAndCashOut() {
			//console.log("there was a change to buy ins", this.hasBeenBlockedForBuyInAndCashOut);
		}

	},
	created() {
		this.eventBus.on("casinoSelected", (selected) => {});
		onBeforeUnmount(() => {
			this.eventBus.off("casinoSelected");
		});
		if(this.webPayOptions.isEmailVerified){
			this.buyInMaxThresholdCOC = this.systemCurrencyTool.formatCurrency(
								this.webPayOptions?.taxAmlRestrictions?.buyInThresholdCOC-1,
								this.systemCurrencyTool.displayType.minorWholeOrFull);
			this.cashOutThresholdCOC = this.systemCurrencyTool.formatCurrency(
								this.webPayOptions?.taxAmlRestrictions?.cashOutThresholdCOC-1,
								this.systemCurrencyTool.displayType.minorWholeOrFull);
		}
		else{
			this.buyInMaxThresholdCOC = this.systemCurrencyTool.formatCurrency(
								0,
								this.systemCurrencyTool.displayType.minorWholeOrFull);

			this.cashOutThresholdCOC = this.systemCurrencyTool.formatCurrency(
								0,
								this.systemCurrencyTool.displayType.minorWholeOrFull);
		}
		this.getAvailableOffersForPlayer();
	},
	mounted() {
		if(this.playerState?.casinoBalances.length == 0 || this.playerState?.casinoBalances[0]?.playthroughThresholdAU == 0){ this.hideProgressBar = true; }
		else{ this.hideProgressBar = false; }
	},
	methods: {
		takeToEditUser() {
			router.push("/userProfile");
		},
		getAvailableOffersForPlayer() {
			let thresholdWithoutDollar = this.buyInMaxThresholdCOC.slice(1);
		
			this.availableOffers.filter( (offer) =>{
				if(offer.minimumCOC > thresholdWithoutDollar){
					return;
				}
				this.availableOffersForPlayer.push(offer);
			});
		},
		createId(item) {
			setTimeout(() => {
				this.setPercentage(item);
			}, 5);
			return `progress-bar-${item}`;

		},

		setPercentage(item){
			document.getElementById(`progress-bar-${item}`).style.width = `${this.getPercentage()}%`;
		},

		getPercentage() {
			if(this.playerState?.casinoBalances[0]?.playthroughProgressAU == 0 && this.playerState?.casinoBalances[0]?.playthroughThresholdAU == 0){ return null;}

			this.percentage = Math.floor((this.playerState?.casinoBalances[0]?.playthroughProgressAU / this.playerState?.casinoBalances[0]?.playthroughThresholdAU) * 100);	
			if(this.playerState.casinoBalances.length == 0){ return 0;}
			 
			return this.percentage;
		},
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.buy-in-offer {
	display: flex;
	flex-flow: row wrap;
}

.input-section div {
	flex-direction: column;
}

#fundsTransfer {
	padding: 15px 15px 5em;
	margin-bottom: 30%;
	/* padding: 15px; */
	height: calc(100vh - 15em);
	overflow: hidden auto;
}

.fundsTransfer {
	width: 100%;
	margin: 30px auto;
}

.fundsTransfer tr {
	cursor: pointer;
}

/* #fundsTransfer::-webkit-scrollbar-track {
	box-shadow: inset 1px 1px 6px rgb(0 0 0 / 75%);
	border-radius: 16px;
	background-color: #434250;
}

#fundsTransfer::-webkit-scrollbar {
	width: 32px;
}

#fundsTransfer::-webkit-scrollbar-thumb {
	border-radius: 16px;
	box-shadow: inset -2px -2px 6px rgb(0 0 0 / 75%);
	background-color: #bccfe5;
} */

#fundsTransfer .input-section {
	background-color: #24272c;
	padding: 30px;
	border-radius: 8px;
	/* box-shadow: 2px 3px 8px rgb(0 0 0 / 75%), inset 4px 3px 10px 4px rgb(42 63 88 / 30%),
		inset -2px -2px 10px 2px rgb(0 0 0 / 30%); */
}

.card-container {
	display: block;
	/* padding: 15px; */
}

.card {
	position: relative;
	/* margin: 15px auto; */
	padding: 15px;
	background-color: #bccfe5;
	color: #000;
	font-weight: bold;
	border-radius: 0.5em;
	/* box-shadow: 2px 3px 5px 0px hsl(0deg 0% 0% / 70%); */
	user-select: none;
	min-width: calc(100% - 30px);
	background-image: url("../../public/styleOverrides/encore_online_pixel_bg.png");
	background-size: cover;
}

.transfer,
.reprint {
	margin: 5px auto;
}

.card-container.is-mobile {
	margin-bottom: 15px;
	padding-bottom: 100px;
	width: 92vw;
}

.separate-buttons {
	margin-right: 15px;
}
.meter {
	box-sizing: content-box;
  	height: 8px;
  	position: relative;
  	background: #ccc;
  	border-radius: 25px;
  	padding: 7px;
  	box-shadow: inset 0 -1px 1px rgba(255, 255, 255, 0.507);
	width: 70%;
}

.meter > span {
  display: block;
  height: 100%;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  background-color: #6305C9;
  background-image: linear-gradient(
    center bottom,
   #6305C9 37%,
   #6305C9 69%
  );
  box-shadow: inset 0 2px 9px rgba(255, 255, 255, 0.3),
    inset 0 -2px 6px rgba(0, 0, 0, 0.4);
  position: relative;
  overflow: hidden;
}

.meter > span:after,
.animate > span > span {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-image: linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.2) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.2) 75%,
    transparent 75%,
    transparent
  );
  z-index: 1;
  background-size: 50px 50px;
  animation: move 2s linear infinite;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  overflow: hidden;
}

.animate > span:after {
  display: none;
}

.progress-bar-percentage {
	margin-left: 3%;
}

.progress-bar-section {
	display: flex;
	margin-top: 1vh;
}

.space-between-bar-and-number {
	margin-left: 5px;
	margin-right: 5px;
}

@keyframes move {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 50px 50px;
  }
}

.center-content {
	display: flex;
	justify-content: center;
}

@media (min-width: 768px) {
	.card-container {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(33%, 1fr));
		column-gap: 2%;
	}

	.card-container.two-col {
		grid-template-columns: repeat(auto-fill, minmax(48%, 1fr));
	}

	.card-container.three-col {
		grid-template-columns: repeat(auto-fill, minmax(30%, 1fr));
	}

	.two-col .card {
		width: 95%;
	}
}

.info-button {
	display: flex;
	flex-flow: row;
	margin: auto;
	justify-content: center;
}

.info-button .btn {
	margin-bottom: 15px;
	text-decoration: none;
}

.text-center {
	text-align: center;
}

.logo-image {
	margin: auto;
	display: block;
	text-align: center;
	max-width: 100%;
	object-fit: contain;
	width: 30%;
}

@media (min-width: 1024px) {
	.card-container {
		grid-template-columns: repeat(auto-fill, minmax(32%, 1fr));
	}
}

.encore-background {
	background-image: url("../../public/styleOverrides/encore_online_pixel_bg.png");
	background-size: cover;
}

.mobile-grid {
	display: grid;
	justify-content: center;
}

@media (max-width: 767px){
	#fundsTransfer {
		height: auto;
	}
}
</style>
